module.exports = [
	{
		"scene": {
			"id": 1,
			"width": "100%",
			"height": 400,
			"image": "../images/coral.jpg",
			"is_stereo": true,
			"is_debug": false,
			"title": "Scene 1. Initial Scene",
			"description": "<div>• Hotspot (1) → Scene (2)</div><div>• Hotspot (2) → No scene defined</div><div>• Hotspot (3) → Execute Function</div>"
		},
		"hotspots": [
			{
				"name": "scene1-hotspot1",
				"pitch": 0,
				"yaw": 0,
				"radius": 0.05,
				"distance": 2,
				"idNewScene": 2
			},
			{
				"name": "scene1-hotspot2",
				"pitch": 0,
				"yaw": -35,
				"radius": 0.05,
				"distance": 2
			},
			{
				"name": "scene1-hotspot3",
				"pitch": -20,
				"yaw": -25,
				"radius": 0.05,
				"distance": 2,
				"clickFn": "alert('Function executed');"
			}
		]
	},
	{
		"scene": {
			"id": 2,
			"is_debug": true,
			"image": "../images/landscape1.jpg",
			"is_stereo": false,
			"title": "Scene 2",
			"description": "<div>• Hotspot (3) → Scene (3)</div><div>• Hotspot (4) → Scene (4)</div>"
		},
		"hotspots": [
			{
				"name": "scene2-hotspot3",
				"pitch": 0,
				"yaw": 0,
				"radius": 0.05,
				"distance": 2,
				"idNewScene": 3
			},
			{
				"name": "scene2-hotspot4",
				"pitch": 0,
				"yaw": -35,
				"radius": 0.05,
				"distance": 2,
				"idNewScene": 4
			}
		]
	},
	{
		"scene": {
			"id": 3,
			"image": "../images/palmbeach.jpg",
			"is_stereo": false,
			"title": "Scene 3",
			"description": "<div>• Hotspot (5) → Scene (4)</div>"
		},
		"hotspots": [
			{
				"name": "scene3-hotspot5",
				"pitch": -10,
				"yaw": 0,
				"radius": 0.05,
				"distance": 2,
				"idNewScene": 4
			}
		]
	},
	{
		"scene": {
			"id": 4,
			"image": "../images/landscape2.jpg",
			"is_stereo": false,
			"title": "Scene 4",
			"description": "This is scene 4 without hotspots"
		}
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/scenes/scenes.json
// module id = 240
// module chunks = 0